import { render, staticRenderFns } from "./rightsList.vue?vue&type=template&id=3da5b18d&scoped=true"
import script from "./rightsList.vue?vue&type=script&lang=js"
export * from "./rightsList.vue?vue&type=script&lang=js"
import style0 from "./rightsList.vue?vue&type=style&index=0&id=3da5b18d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da5b18d",
  null
  
)

export default component.exports